(ns frontend.state.account
  (:require [promesa.core :as p]
            [frontend.conn :as conn]
            [frontend.state.current-session :as current-session]))

(defn update-account!
  [on-success! on-error! account-changes role-changes send-email?]
  (-> (conn/sendp! :account/update
                   (merge {:send-email? send-email?}
                          (when account-changes {:account account-changes})
                          (when role-changes {:role role-changes})))
      (p/then (comp on-success! :body))
      (p/catch (partial on-error!))))

(defn re-invite-account! [on-success! on-error! account role]
  (-> (conn/sendp! :account/re-invite-account
                   {:account/email (:account/email (get @current-session/entities (:db/id account)))
                    :role-id       (:db/id role)})
      (p/then on-success!)
      (p/catch on-error!)))

(defn invite-account! [on-success! on-error! data]
  (-> (conn/sendp! :account/invite data)
      (p/then on-success!)
      (p/catch on-error!)))
